/** Mandanten-Slug für Schulungs-/Test-Hosts (test.*). */
export const TRAINING_TENANT_SLUG = "test";
const TEST_HOST_PREFIXES = [
    "test.app.",
    "test.booking.",
    "test.shop.",
    "test.www.",
    "test.neu.",
];
export function isTestAppHost(hostname) {
    return hostname.startsWith("test.app.");
}
export function isTestBookingHost(hostname) {
    return hostname.startsWith("test.booking.");
}
export function isTestShopHost(hostname) {
    return hostname.startsWith("test.shop.");
}
export function isTestWebsiteHost(hostname) {
    return hostname.startsWith("test.www.") || hostname.startsWith("test.neu.");
}
export function isTrainingHost(hostname) {
    return TEST_HOST_PREFIXES.some((prefix) => hostname.startsWith(prefix));
}
/** Liefert den Schulungs-Mandanten-Slug, wenn der Host ein Test-Host ist. */
export function tenantSlugFromHostname(hostname) {
    if (isTrainingHost(hostname))
        return TRAINING_TENANT_SLUG;
    return null;
}
export function resolveTenantSlug(options) {
    const hostname = options.hostname ??
        (typeof window !== "undefined" ? window.location.hostname : "");
    const fromHost = tenantSlugFromHostname(hostname);
    if (fromHost)
        return fromHost;
    const fromMeta = options.fromMeta?.trim();
    if (fromMeta)
        return fromMeta.toLowerCase();
    const fromEnv = options.fromEnv?.trim();
    if (fromEnv)
        return fromEnv.toLowerCase();
    return "default";
}
